import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';

export const renderSensorName = (params: GridRenderCellParams<any, any, any>) => {
  const row: any = params.row;
  return (
    <Tooltip title={row.name || ''} enterDelay={350} enterNextDelay={350}>
      <div className="data-grid-cell-ellipsis data-grid-cell-pointer">{row.name}</div>
    </Tooltip>
  );
};
